import { GRADIENTS, ModuleGradient } from '../../config/designSystem/Colors';
import { useStores } from '../../hooks/useStores';

/**
 * Container-side context for diary/challenge frames: the current activity and
 * its module gradient, resolved from the session being played.
 */
export const useDiaryFrame = () => {
  const rootStore = useStores();
  const { treeNav } = rootStore;

  const sessionId = treeNav.content.session?._id;
  const activity = sessionId
    ? (rootStore as any).activity?.getActivityBySessionId(sessionId)
    : undefined;
  const designSystemColor: string = activity?.designSystemColor || 'LAVENDER';
  const moduleGradient = (GRADIENTS.modules[designSystemColor] || GRADIENTS.modules.LAVENDER) as ModuleGradient;

  return { activity, designSystemColor, moduleGradient };
};
